import Http from './../http';

const prefix = '/external_images';

export const getImages = () => {
  return Http.authApi().get(`${prefix}/get`);
};

export const uploadImage = data =>
  Http.authApi().post(`${prefix}/upload`, { data });



// WEBPACK FOOTER //
// ./src/js/services/editor/externalImage.js